/* uc-cart-compact-v2-20261104: unpublished UniCurt theme presentation only.
 * No fetch, cart writes, price changes, form interception or checkout handling.
 */
(() => {
  'use strict';
  if (String(window.Shopify?.theme?.id) !== '188133015737' || window.__ucCartCompact) return;
  window.__ucCartCompact = 'uc-cart-compact-v2-20261104';
  const watched = new WeakSet(), initialized = new WeakSet(), openState = new Map();
  function setupDetails(root) {
    root.querySelectorAll('.addons-accordion details, #main-cart-discount details').forEach((details, index) => {
      if (initialized.has(details)) return;
      initialized.add(details);
      const summary = details.querySelector('summary');
      const key = root.tagName + ':' + (summary?.textContent.trim() || 'addon') + ':' + index;
      // Discount input starts open; keep the other add-ons compact.
      // Preserve a customer's explicit choice across section refreshes.
      const open = openState.get(key) ?? Boolean(details.querySelector('cart-discount'));
      details.open = open;
      details.classList.toggle('is-open', open);
      const wrapper = details.querySelector('.collapsible__content-wrapper');
      const content = details.querySelector('.collapsible__content');
      if (wrapper) wrapper.style.height = open ? 'auto' : '0px';
      if (content) content.style.transform = open ? 'translateY(0)' : 'translateY(16px)';
      if (summary?.hasAttribute('aria-expanded')) summary.setAttribute('aria-expanded', String(open));
      details.addEventListener('toggle', () => {
        openState.set(key, details.open);
        if (summary?.hasAttribute('aria-expanded')) summary.setAttribute('aria-expanded', String(details.open));
      });
    });
  }
  function reconcile(root) {
    root.classList.add('uc-cart-compact');
    if (root.matches('cart-drawer')) {
      const items = root.querySelector('#CartDrawer-CartItems');
      // Never invent cart contents; clear stale state only when real rows were rendered.
      if (items?.querySelector('.cart-item')) {
        root.classList.remove('is-empty');
        root.querySelector('.drawer__inner')?.classList.remove('is-empty');
        root.querySelector('cart-drawer-items')?.classList.remove('is-empty');
      }
    }
    setupDetails(root);
    // A pre-existing unexpected service quantity must remain disclosed, not silently reset.
    root.querySelectorAll('.cart-item input[data-quantity-variant-id="68089385025721"]').forEach(input => {
      const row = input.closest('.cart-item');
      row.classList.add('uc-photo-cart-item');
      let warning = row.querySelector('[data-uc-service-quantity-warning]');
      if (Number(input.value) > 1) {
        if (!warning) {
          warning = document.createElement('p');
          warning.dataset.ucServiceQuantityWarning = '';
          warning.className = 'cart-item__custom-note';
          row.querySelector('.cart-item__details')?.append(warning);
        }
        const text = 'Quantity: ' + input.value + '. Only one service is needed; remove this line and add it once.';
        if (warning.textContent !== text) warning.textContent = text;
      } else if (warning) warning.remove();
    });
  }
  function observe(root) {
    if (watched.has(root)) return;
    watched.add(root);
    let scheduled = false;
    const observer = new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        if (root.isConnected) reconcile(root);
      });
    });
    observer.observe(root, { childList:true, subtree:true });
    reconcile(root);
  }
  function init() { document.querySelectorAll('cart-drawer, #main-cart-items').forEach(observe); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once:true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
